@let obs =
  {
    isTabletUp: isTabletUp$ | async,
  };

@if (bannerNumberShop$ | async; as banner) {
  <div
    class="banner-number-shop container-v2"
    [sdInViewport]="0.5"
    [intersectedOnce]="true"
    (intersected)="onBannerIntersect(banner)"
  >
    <div class="banner-number-shop-image" (click)="onClickBanner(banner)">
      <sd-generic-link [url]="banner.link">
        <img [ngSrc]="banner.url" [alt]="banner.altText" fill />
      </sd-generic-link>
    </div>
    <sd-generic-link
      [url]="banner.link"
      class="banner-number-shop-content"
      role="link"
      tabindex="0"
      (click)="onClickBanner(banner)"
    >
      <div class="banner-number-shop-content-inner">
        <h3
          class="text-secondary-h1-s text-secondary-md-h1-m text-secondary-lg-h1-l text-secondary-xxl-h1-xl banner-number-shop-content-banner-title"
        >
          {{ countShopTitle$ | async }}
        </h3>
        <p class="text-b2-s-300 text-md-b3-s-300 text-lg-h3-s banner-number-shop-content-banner-text">
          {{ banner.bannerText }}
        </p>
        @if (obs.isTabletUp) {
          <button sdButton type="button" [theme]="'secondary'">
            {{ banner.buttonText }}
          </button>
        } @else {
          <span class="link-icon link-black link-hover-black link-hover-underlined">
            <sd-icon [type]="iconTypes.ARROW_NEXT_LONG" class="color-black-warm"></sd-icon>
          </span>
        }
      </div>
    </sd-generic-link>
  </div>
} @else if (isLoading$ | async) {
  <div class="banner-number-shop container-v2 sd-group-skeleton-gradient-wave">
    <div class="banner-number-shop-image sd-skeleton"></div>
    @if (obs.isTabletUp) {
      <div class="banner-number-shop-content sd-skeleton"></div>
    } @else {
      <div class="banner-number-shop-content">
        <div class="banner-number-shop-content-banner-title sd-skeleton"></div>
        <div class="banner-number-shop-content-banner-text sd-skeleton"></div>
        <div class="banner-number-shop-content-banner-button sd-skeleton"></div>
      </div>
    }
  </div>
}
